import { render, staticRenderFns } from "./crmLoader.vue?vue&type=template&id=b2a78e78&scoped=true"
import script from "./crmLoader.vue?vue&type=script&lang=js"
export * from "./crmLoader.vue?vue&type=script&lang=js"
import style0 from "./crmLoader.vue?vue&type=style&index=0&id=b2a78e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a78e78",
  null
  
)

export default component.exports